module.exports = __webpack_public_path__ + "media/images/portugal_center/coimbra3-067c3acf7feedbfdce6c77655e62f951.jpg";